import { css } from '@emotion/react';

import color from '../color';

export const tableContainerStyles = css`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  width: 100%;
  min-height: 0;
`;

export const paperStyles = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
`;

export const scrollContainerStyles = css`
  flex: 1;
  min-height: 0;
`;

// Matches Table2's header and body cells.
export const headerCellStyles = css`
  font-size: 14px;
  font-weight: bold;
  padding: 4px;
  text-transform: capitalize;
`;

export const bodyCellStyles = css`
  font-size: 12px;
  font-weight: normal;
  padding: 4px;

  span, p {
    font-size: 12px;
    white-space: pre-line;
    text-transform: capitalize;

    &.lowercase {
      text-transform: lowercase;
    }
  }

  div.couple-spans {
    display: flex;
    align-items: center;
    gap: 8px;

    button {
      border-radius: 5px;
      padding: 5px;
      height: 32px;
      text-transform: capitalize;
      cursor: pointer;

      a {
        text-decoration: none;
        text-transform: capitalize;
        color: ${color.BLACK};
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
`;

export const linkStyles = css`
  display: block;
  text-decoration: none;
  color: ${color.BLACK};
`;
